module.exports = {"Enterprise13":{"daobanList":[{"title":"1:是否民办非企业单位的变更登记(变更名称)","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、变更登记申请表","state":"必要"},{"name":"2、会议纪要","state":"必要"},{"name":"3、业务主管单位审核意见","state":"必要"},{"name":"4、原法人证书正副本","state":"必要"},{"name":"5、民办非企业单位理（董）事会会议纪要","state":"必要"},{"name":"6、前置审批许可证","state":"非必要"},{"name":"7、社会服务机构章程核准表、民办学校提交《民办学校章程备案表》、章程修改","state":"必要"},{"name":"8、章程（新章程2份、旧章程1份）","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sde-13.json
// module id = 1244
// module chunks = 0